import { createNotFoundSegment } from './Segments';
export var NaviNodeType;

(function (NaviNodeType) {
  NaviNodeType["Switch"] = "switch";
  NaviNodeType["Page"] = "page";
  NaviNodeType["Redirect"] = "redirect";
  NaviNodeType["Context"] = "context";
})(NaviNodeType || (NaviNodeType = {}));

var NodeMatcher =
/** @class */
function () {
  function NodeMatcher(options, wildcard) {
    if (wildcard === void 0) {
      wildcard = false;
    }

    this.appendFinalSlash = !!options.appendFinalSlash;
    this.env = options.env;
    this.resolver = options.resolver;
    this.withContent = !!options.withContent;
    this.wildcard = wildcard;
  } // Get the segment object given the current state.


  NodeMatcher.prototype.getResult = function () {
    var unmatchedPathnamePart = this.env.unmatchedPathnamePart;

    if (this.wildcard || !unmatchedPathnamePart || unmatchedPathnamePart === '/') {
      return this.execute();
    } else {
      // This switch couldn't be matched due to missing required
      // params, or a non-exact match without a default path.
      return {
        resolutionIds: [],
        segment: createNotFoundSegment(this.env)
      };
    }
  };

  ;
  return NodeMatcher;
}();

export { NodeMatcher };